<template>
  <FreeBottomSheet :name="roamingConfig.SELECT_BRAND_BOTTOM_SHEET">
    <template #header="{ hide }">
      <FreeHeader class="bg-background-neutral-primary rounded-t-2xl p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ t('roamingDevices.choose-brand') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="bg-background-neutral-primary px-4 pb-4">
        <div
          class="bg-background-neutral-secondary divide-situational-lightgrey divide-y rounded-xl px-4"
        >
          <button
            v-for="device in Object.keys(roamingConfig.INSTRUCTIONS_BRANDS)"
            :key="device"
            type="button"
            class="flex w-full items-center justify-between py-4"
            @click="onSelectBrand(device, hide)"
          >
            <span
              class="font-semibold"
              :class="
                selectedBrand === device
                  ? 'text-text-positive-primary'
                  : 'text-text-neutral-secondary'
              "
            >
              {{ roamingConfig.INSTRUCTIONS_BRANDS[device] }}
            </span>
            <img
              v-if="selectedBrand === device"
              src="./assets/tick-icon.svg"
              class="h-6 w-6"
              width="24"
              height="24"
              alt=""
              role="presentation"
            />
          </button>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { ref } from 'vue';
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';

  import { roamingConfig } from '../config';

  const { t } = useI18n();

  const props = defineProps<{
    selectedBrand: string;
  }>();

  const emit = defineEmits<{
    onSelectBrand: [string];
  }>();

  const selectedBrand = ref<string>(
    props.selectedBrand || Object.keys(roamingConfig.INSTRUCTIONS_BRANDS)[0],
  );

  function onSelectBrand(brand: string, hide: () => void) {
    selectedBrand.value = brand;
    emit('onSelectBrand', brand);
    hide();
  }
</script>

<i18n src="../locales.json" />
